import React from 'react';

export function RankingCard({ title, items, formatValue }) {
  return (
    <div className="bg-white dark:bg-slate-900 rounded-lg border border-gray-200 dark:border-slate-700 p-6 shadow-sm">
      <h3 className="text-sm font-semibold text-gray-900 dark:text-white mb-4">{title}</h3>
      <div className="space-y-3">
        {items.map((item, idx) => {
          const percent = item.max > 0 ? (item.value / item.max) * 100 : 0;
          return (
            <div key={idx} className="flex items-center gap-3">
              <div className="text-xs font-bold text-gray-600 dark:text-gray-400 w-6">{idx + 1}</div>
              <div className="flex-1">
                <div className="flex justify-between items-center mb-1">
                  <span className="text-sm font-medium text-gray-900 dark:text-white">{item.name}</span>
                  <span className="text-xs text-gray-600 dark:text-gray-400">{formatValue ? formatValue(item.value) : item.value}</span>
                </div>
                <div className="h-2 bg-gray-200 dark:bg-slate-700 rounded-full overflow-hidden">
                  <div
                    className="h-full bg-blue-600 dark:bg-blue-500 transition-all duration-300"
                    style={{ width: `${percent}%` }}
                  />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
